import { useEffect, type VFC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ENTITY_TYPE } from "@/settings/settings.ts";

import { useURLViewID } from "../../app-utils/hooks/useUrl.js";
import { type InputTableQuerySpec, type Protein } from "../../graphql.js";
import { updateLastOpenProteinFeatureTableSpec } from "../../redux/modules/protein.js";
import { loadView } from "../../redux/modules/saved-view.js";
import { type IAppState } from "../../redux/reducer.js";
import { type ReduxDispatch } from "../../redux/redux-utils.js";
import ProteinFeatureSelector from "./ProteinFeatureSelector.js";
import ProteinRelatedEntitiesView from "./ProteinRelatedEntitiesView.js";

const ProteinRelatedProteinFeaturesView: VFC = () => {
  const dispatch = useDispatch<ReduxDispatch>();
  const viewId = useURLViewID();
  const protein = useSelector<IAppState, Protein>((state) => state.protein.protein);
  const lastOpenFeatureTableSpec = useSelector<IAppState, InputTableQuerySpec>(
    (state) => state.protein.lastOpenFeatureTableSpec,
  );

  useEffect(() => {
    dispatch(loadView(viewId)).then((view) => {
      dispatch(updateLastOpenProteinFeatureTableSpec(view?.state?.tableView?.tableQuerySpec));
    });
  }, []);

  return (
    <ProteinRelatedEntitiesView
      subtitle="List of Protein Features"
      /* when looking at aa features, show a selection widget for the aa feature types*/
      middleToolbarElement={<ProteinFeatureSelector protein={protein} />}
      relatedEntitiesType={lastOpenFeatureTableSpec?.resultType}
      relatedEntitiesSubType={lastOpenFeatureTableSpec?.resultSubTypeId}
      expectedEntityType={ENTITY_TYPE.AAFEATURE}
    />
  );
};

export default ProteinRelatedProteinFeaturesView;
